import React, { useState, useEffect } from "react";
import { useEventContext } from "../../context/EventContext";
import { useLocaleContext } from "../../context/LocaleContext";
import { activityTopGetCalculated } from "../../utils/api";
import { Event } from "../../../../cp/components/Comet";
import './style.scss';
import CTable from "../../components/UI/CTable";
import { formatNumber } from "../../utils/formatting";
import { UserAvatar } from "../../components/User";
import LoadingMessage from "../../components/LoadingMessage";
import ActivityTopCard from "./components/ActivityTopCard";
import { CButton } from "../../components/UI";
import { ModalContextProvider, useModalContext } from "../../context/ModalContext";
import ActivityTopModal from "./components/ActivityTopModal";

const tableColumns = (getLocale) => [
    {
        field: 'index',
        displayName: '№',
        align: 'right',
        width: '2rem'
    },
    {
        field: 'client',
        displayName: getLocale('common.user'),
        render: (row) => <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <UserAvatar user={row?.client} />
            <span>{row?.nickname}</span>
        </div>
    },
    {
        field: 'points',
        displayName: getLocale('common.points'),
        align: 'right',
        width: '3rem'
    },
];

const handleData = (data) => data.map(({ nickname, points }, index) => ({
    index: index + 1,
    nickname,
    points: formatNumber(points),
}))

export default ({ block = {} }) => {
    const { eventKey } = useEventContext();
    const { get: getLocale, getProperty } = useLocaleContext();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const getData = async (eventKey) => {
        setLoading(true);
        try {
            const response = await activityTopGetCalculated(eventKey);
            setData(handleData(response?.[0]?.top || []));
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getData(eventKey);
    }, [eventKey]);

    const renderDescription = (description) => {
        if (!description || !description.enabled) return null;

        return <div className="page-block-subtitle" style={{ color: "#" + description.textColor, fontSize: description.textSize }}>
            {getProperty(description, 'text')}
        </div>
    }

    const title = getProperty(block, 'title');
    const separateTopDisplay = block.topRatedSeparateDisplay;
    const columns = tableColumns(getLocale);
    const tableData = data.slice(separateTopDisplay ? 3 : 0, 20);

    return (
        <section className={"page-block activity-rating-block"}>
            <Event event={'activityTop'} handler={(top) => setData(handleData(top?.[0]?.top || []))} />
            <div className="page-block-header">
                <h1 className="page-block-title">
                    {title}
                </h1>
            </div>
            {block?.imageUrl && <img alt="" src={block.imageUrl} />}
            {renderDescription(block.descriptionSettings)}
            {loading ?
                <div style={{ height: '10rem' }}><LoadingMessage isPreloader /></div> :
                <>
                    {separateTopDisplay && <div className="activity-rating-top">
                        {data.slice(0, 3).map((item, idx) => <ActivityTopCard item={item} key={idx} />)}
                    </div>}
                    <CTable
                        columns={columns}
                        data={tableData}
                        height="380px"
                    />
                </>
            }
            <ModalContextProvider>
                {data.length > 20 && <div className="page-block-footer">
                    <SeeAllButton title={title} data={data} columns={columns} handleData={handleData} />
                </div>}
            </ModalContextProvider>
        </section>
    );
}

const SeeAllButton = ({ title, data, columns, handleData }) => {
    const { renderModal } = useModalContext();
    const { get: getLocale } = useLocaleContext();
    return <CButton
        label={getLocale('blocks.activityTop.seeAll')}
        size="lg"
        onClick={() => renderModal(ActivityTopModal, { title, data, columns, handleData, lockPageScroll: false, })}
    />
}